import React from 'react';
import OccurrenceTypesShared from '../shared/OccurrenceTypes';

export default function OccurrenceTypes() {


  return (
    <OccurrenceTypesShared />
  );
}
